var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeImprovement14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58081 17.5966C6.58081 18.1271 6.3701 18.6358 5.99502 19.0108C5.61995 19.3859 5.11124 19.5966 4.58081 19.5966C4.05038 19.5966 3.54167 19.3859 3.1666 19.0108C2.79152 18.6358 2.58081 18.1271 2.58081 17.5966C2.58081 16.4916 4.58081 13.5966 4.58081 13.5966C4.58081 13.5966 6.58081 16.4916 6.58081 17.5966Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4929 21.4524L18.9869 16.9434C19.3921 16.0944 19.5241 15.1408 19.3649 14.2137C19.2057 13.2866 18.763 12.4316 18.0979 11.7664C17.4327 11.1013 16.5778 10.6586 15.6507 10.4994C14.7236 10.3402 13.7699 10.4723 12.9209 10.8774L14.3449 12.3024C14.6292 12.5867 14.789 12.9723 14.789 13.3744C14.789 13.7765 14.6292 14.1621 14.3449 14.4464C14.0606 14.7307 13.675 14.8904 13.2729 14.8904C12.8709 14.8904 12.4852 14.7307 12.2009 14.4464L10.7739 13.0214C10.3688 13.8704 10.2368 14.824 10.396 15.7511C10.5552 16.6782 10.9978 17.5332 11.663 18.1983C12.3281 18.8635 13.1831 19.3061 14.1102 19.4654C15.0373 19.6246 15.991 19.4925 16.8399 19.0874L21.3489 23.5964",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33081 2.09662H20.3308",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33081 7.09662H6.83081V9.59662C6.83081 9.86184 6.72545 10.1162 6.53791 10.3037C6.35038 10.4913 6.09602 10.5966 5.83081 10.5966H2.08081C1.81559 10.5966 1.56124 10.4913 1.3737 10.3037C1.18617 10.1162 1.08081 9.86184 1.08081 9.59662V3.34662C1.08081 2.81619 1.29152 2.30748 1.6666 1.93241C2.04167 1.55733 2.55038 1.34662 3.08081 1.34662H9.33081V7.09662Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3308 6.09662H9.33081",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.286987 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImprovement14);
export default __webpack_public_path__ + "static/media/home-improvement-14.063d73ed97082bf655250879ec3e4b8c.svg";
export { ForwardRef as ReactComponent };